import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('gummy_lab', {
  cherry: 'red_gummy_bear',
  lemon: 'gummy_worm',
  orange: 'jelly_slice',
  bell: 'green_gummy_bear',
  star: 'gummy_wild',
  seven: 'beaker_brew',
  gem: 'sour_crystal',
  scatter: 'gummy_flask',
  money: 'gummy_vault',
});

/** Gummy Lab — GENERATED by scaffoldSlot from
 *  content/slots/gummy_lab.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const GUMMY_LAB_THEME: Theme = {
  id: 'gummy_lab',
  name: 'Gummy Lab',
  palette: {
    accent: 0x2ec5b6,
    secondary: 0xff4d6d,
    warm: 0xffc24d,
    frameFill: 0x0d2a2a,
    bgGradientTop: 0x103535,
    bgGradientBottom: 0x061414,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Red Gummy Bear', glyph: '🧸', tint: 0xff4d6d, weight: 5, textureAlias: 'gummy_lab:cherry',
        winVideoAlias: 'gummy_lab:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Gummy Worm', glyph: '🪱', tint: 0xffc24d, weight: 5, textureAlias: 'gummy_lab:lemon',
        winVideoAlias: 'gummy_lab:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Jelly Slice', glyph: '🍊', tint: 0xff8a3c, weight: 4, textureAlias: 'gummy_lab:orange',
        winVideoAlias: 'gummy_lab:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Green Gummy Bear', glyph: '🐻', tint: 0x4caf50, weight: 3, textureAlias: 'gummy_lab:bell',
        winVideoAlias: 'gummy_lab:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Gummy Wild', glyph: '⭐', tint: 0xff4d6d, weight: 2, textureAlias: 'gummy_lab:star',
        winVideoAlias: 'gummy_lab:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Bubbling Beaker', glyph: '⚗️', tint: 0x2ec5b6, weight: 2, textureAlias: 'gummy_lab:seven',
        winVideoAlias: 'gummy_lab:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Sour Sugar Crystal', glyph: '💎', tint: 0xff4d6d, weight: 2.5, textureAlias: 'gummy_lab:gem',
        winVideoAlias: 'gummy_lab:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Gummy Flask', glyph: '🧫', tint: 0xffc24d, weight: 0.5, textureAlias: 'gummy_lab:scatter',
        winVideoAlias: 'gummy_lab:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Candy Lab Vault', glyph: '🪙', tint: 0xffc24d, weight: 1, textureAlias: 'gummy_lab:money',
        winVideoAlias: 'gummy_lab:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x0d2a2a, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x2ec5b6, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xffc24d, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xff4d6d, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x2ec5b6, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xffc24d, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xffc24d, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x0d2a2a, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xff4d6d, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x2ec5b6, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xffc24d, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xffc24d, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'gummy_lab:bg', path: 'environment/gummy_lab.png' },
      columnBackground: { alias: 'gummy_lab:column_bg', path: 'reel/gummy_lab_column_bg.png' },
      border: { alias: 'gummy_lab:border', path: 'brand/border_candy.png' },
    },
  },
};
